import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db, auth } from "../config/firebase"; // Import Firestore and Auth
import { doc, setDoc, collection, updateDoc, arrayUnion } from "firebase/firestore"; // Firestore methods
import Footer from "../components/footer";
import "./confirmation.css"; // Optional: Add relevant styles

const Confirmation = () => {
  const { state } = useLocation(); // Get state passed via navigate
  const { selectedStudents, totalCost, course } = state || {};
  const navigate = useNavigate(); // For redirecting in case of errors

  useEffect(() => {
    // Log the course object to the console to inspect its structure
    console.log("Course Object:", course);

    // Get the logged-in user's ID from Firebase Auth
    const currentUser = auth.currentUser;
    const userId = currentUser?.uid;

    if (!userId) {
      console.error("User is not logged in or User ID is missing. Redirecting to login.");
      navigate("/login"); // Redirect to login if userId is undefined
      return;
    }

    // Save enrollment data and update courseCompleted array for each student
    selectedStudents.forEach(async (student) => {
      try {
        // 1. Save enrollment details in "Users/{userId}/Enrollments/{enrollmentId}"
        const enrollmentCollectionRef = collection(db, "Users", userId, "Enrollments");
        const enrollmentDocRef = doc(enrollmentCollectionRef);

        await setDoc(enrollmentDocRef, {
          courseId: course.id, // Course ID
          studentId: student.id, // Student ID
          studentName: `${student.firstName} ${student.middleName} ${student.lastName}`, // Full name
          enrollmentDate: new Date(), // Today's date
        });

        console.log(`Enrollment saved for student ${student.id} under user ${userId}.`);

        // 2. Update the "Users/students/{studentId}" document to append course ID to courseCompleted array
        const studentDocRef = doc(db, "Users", "Students", student.id);

        await updateDoc(studentDocRef, {
          courseComplete: arrayUnion(String(course.id)), // Add course ID as a string
        });

        console.log(`Course ID ${course.id} added to courseCompleted array for student ${student.id}.`);
      } catch (error) {
        console.error(`Error processing student ${student.id}:`, error);
      }
    });
  }, [selectedStudents, course, navigate]);

  return (
    <div className="confirmation-page">
      <div className="confirmation-container">
        <h1 className="thank-you">Thank You for Enrolling!</h1>
        <p className="thank-you-messages">
          Your students have been successfully enrolled in the course "{course?.Title}". We are excited to have them join!
        </p>

        <div className="course-details">
          <h2>Course Details:</h2>
          <p><strong>Course Title:</strong> {course?.Title}</p>
          <p><strong>Description:</strong> {course?.Description}</p>
          <p><strong>Start Date:</strong> {course?.StartDate}</p>
          <p><strong>End Date:</strong> {course?.EndDate}</p>
        </div>

        <div className="students-details">
          <h3>Enrolled Students:</h3>
          <ul>
            {selectedStudents?.map((student) => (
              <li key={student.id}>
                <strong>{student.firstName} {student.middleName} {student.lastName}</strong>
                <br />
                <small>ID: {student.id}</small>
              </li>
            ))}
          </ul>
        </div>

        <div className="cost-summary">
          <p><strong>Total Enrollment Cost:</strong> ${totalCost}</p>
          <p className="payment-confirmation">
            Your payment has been successfully processed. A confirmation email will be sent shortly.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Confirmation;
